<div class="modal-body content width-600 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header.route')}} {{dataInit ? getRessource('create') : getRessource('edit')}}
    </span>
		<div class="content layout-1-auto">
			<div class="">
				<div class="grid cols-2">
					<exg-input [ngModel]="dataModelClone.from | date:'yyyy-MM-dd'"
					           (ngModelChange)="dataModelClone.from = $event" type="date"
					           [caption]="getRessource('from')"
					           [required]="dateValid(dataModelClone.from, dataModelClone.to)" [hintText]="hintText.dFromdTo"
					           #VCfrom name="from">
					</exg-input>
					<exg-input [ngModel]="dataModelClone.to | date:'yyyy-MM-dd'"
					           (ngModelChange)="dataModelClone.to = $event" type="date"
					           [caption]="getRessource('to')"
					           [required]="dateValid(dataModelClone.from, dataModelClone.to)" [hintText]="hintText.dFromdTo"
		                 #VCto name="to">
					</exg-input>
				</div>
				<div class="grid-1-auto">
					<h6>{{getRessource('Header.region')}}</h6>
					<div class="spawn-reverse">
						<button class="md-btn" (click)="addLocationObject()">{{getRessource('add Loc')}}</button>
					</div>
				</div>
			</div>
			<div class="content list" style="height: 400px">
				<div *ngFor="let location of dataModelClone.locations" class="list-row list-row-1-auto">
					<div class="grid cols-4">
						<exg-input [ngModel]="location.from | date:'yyyy-MM-dd'"
						           (ngModelChange)="location.from = $event" type="date"
						           [required]="location.from && dateValid(dataModelClone.from, dataModelClone.to, location.from)"
						           [hintText]="hintText.tourInValid"
						           [caption]="getRessource('location.from')"
                       #VCfrom name="from">
						</exg-input>
						<exg-input #VCto name="to"
						           [ngModel]="location.to | date : 'yyyy-MM-dd'"
											 (ngModelChange)="location.to = $event"
										 	 type="date"
											 [caption]="getRessource('location.to')"
											 [required]="
				                 location.to &&
				                 dateValid(
				                   dataModelClone.from,
				                   dataModelClone.to,
				                   location.to
				                 )
				               "
											 [hintText]="
				                 location.to && dateValid(
				                       dataModelClone.from,
				                       dataModelClone.to,
				                       location.to
				                     )
				                     ? hintText.tourInValid
				                   : ''">
						</exg-input>

						<exg-input [ngModel]="location.capacity" (ngModelChange)="location.capacity = $event" type="number"
						           [caption]="getRessource('location.capacity')"
                       #VCcapacity name="capacity" class="app-space-left_1">
						</exg-input>
						<exg-input [ngModel]="location.postCode" [maxlength]="5"
						           (ngModelChange)="changePostCode(location, $event)" type="text"
						           (focusout)="focusOutPostCode(location)"
						           [caption]="getRessource('location.postCode')"
                       #VCpostCode name="postCode" class="app-space-left">
						</exg-input>
					</div>
					<div>
						<i class="search-action far fa-trash-alt"
							 (click)="removeRouteItem(location)"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()" [class.disabled]="!appSvc.helperObj.changed(this.dataModel, this.dataModelClone) || dateValid(dataModelClone.from, dataModelClone.to)"
			        class="md-btn">
				{{getGlobal('Save')}}
			</button>
		</div>
	</div>
</div>
